module.exports = __webpack_public_path__ + "static/media/photo4.fde129b5.jpg";